import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export type PhoneNumberWorkflowData = TWorkflowStepData & {
    phoneNumber?: string | null
    workflowType: 'phone-number'
}

export const legacyLodashMapper = (data: unknown): PhoneNumberWorkflowData => {
    return {
        phoneNumber: get(data, 'phoneNumber'),
        workflow: toWorkflowData(data),
        workflowType: 'phone-number',
        user: get(data, '_embedded.user'),
    }
}
